import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';
import { GLOBAL_URLS } from 'constants/common';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc Global defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { GlobalService } from 'services/global';
 *
 * // create service instance and send/cancel request
 * const globalService = new GlobalService();
 * const result = await globalService.fetchData( '<user-id>' ); // fetch data
 * globalService.cancel(); // cancel an active request
 */
export class GlobalService extends HttpService {

    // make alerts calculation request
    async startAlertsCalculation( { memberId, patientId } ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );
        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        // get alerts calculation url from the redux store
        const url = get( store.getState()[ REDUCER.APP_CONTEXT ], `component.data.state.globalUrls.${ GLOBAL_URLS.START_CALCULATING_ALERTS }`, null );

        this.post( {
            host: CONFIG.host,
            path: url,
            data: { context: { callId, callType, callerType, memberId, patientId } }
        } );
    }
}
